import { render, staticRenderFns } from "./LogoutConfirmation.vue?vue&type=template&id=1afdfe38&scoped=true&"
import script from "./LogoutConfirmation.vue?vue&type=script&lang=ts&"
export * from "./LogoutConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./logout-confirmation.scss?vue&type=style&index=0&id=1afdfe38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdfe38",
  null
  
)

export default component.exports